<div class="modal-content email-view-config-modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ title }}</h5>
    <button type="button" class="close" (click)="cancelEvent.emit()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-4" [innerHtml]="'emaildns_config_help' | translate"></div>
    <div class="d-flex">
      <table class="pop-up-table">
        <thead>
          <tr>
            <th translate>emaildns_details_cname</th>
            <th translate>emaildns_details_host</th>
            <th></th>
            <th translate>emaildns_details_value</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="cNameConfiguraion?.dns?.mailCname">
            <td>{{ cNameConfiguraion?.dns?.mailCname?.type | uppercase }}</td>
            <td>
              {{ cNameConfiguraion?.dns?.mailCname?.host }}
            </td>
            <td>
              <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="cNameConfiguraion?.dns?.mailCname?.host" translate>
                common_copy
              </button>
            </td>
            <td class="border-left">{{ cNameConfiguraion?.dns?.mailCname?.data }}</td>
            <td>
              <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="cNameConfiguraion?.dns?.mailCname?.data" translate>
                common_copy
              </button>
            </td>
          </tr>

          <tr *ngIf="cNameConfiguraion?.dns?.mailServer">
            <td>{{ cNameConfiguraion?.dns?.mailServer?.type | uppercase }}</td>
            <td>
              {{ cNameConfiguraion?.dns?.mailServer?.host }}
            </td>
            <td>
              <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="cNameConfiguraion?.dns?.mailServer?.host" translate>
                common_copy
              </button>
            </td>
            <td class="border-left">{{ cNameConfiguraion?.dns?.mailServer?.data }}</td>
            <td>
              <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="cNameConfiguraion?.dns?.mailServer?.data" translate>
                common_copy
              </button>
            </td>
          </tr>

          <tr *ngIf="cNameConfiguraion?.dns?.spf">
            <td>{{ cNameConfiguraion?.dns?.spf?.type | uppercase }}</td>
            <td>
              {{ cNameConfiguraion?.dns?.spf?.host }}
            </td>
            <td>
              <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="cNameConfiguraion?.dns?.spf?.host" translate>
                common_copy
              </button>
            </td>
            <td class="border-left">{{ cNameConfiguraion?.dns?.spf?.data }}</td>
            <td>
              <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="cNameConfiguraion?.dns?.spf?.data" translate>
                common_copy
              </button>
            </td>
          </tr>
          <tr *ngIf="cNameConfiguraion?.dns?.dkim1">
            <td>{{ cNameConfiguraion?.dns?.dkim1?.type | uppercase }}</td>
            <td>
              {{ cNameConfiguraion?.dns?.dkim1?.host }}
            </td>
            <td>
              <button class="btn  btn-primary  btn-sm" [cdkCopyToClipboard]="cNameConfiguraion?.dns?.dkim1?.host" translate>
                common_copy
              </button>
            </td>
            <td class="border-left">{{ cNameConfiguraion?.dns?.dkim1?.data }}</td>
            <td>
              <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="cNameConfiguraion?.dns?.dkim1?.data" translate>
                common_copy
              </button>
            </td>
          </tr>

          <tr *ngIf="cNameConfiguraion?.dns?.dkim2">
            <td>{{ cNameConfiguraion?.dns?.dkim2?.type | uppercase }}</td>
            <td>
              {{ cNameConfiguraion?.dns?.dkim2?.host }}
            </td>
            <td>
              <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="cNameConfiguraion?.dns?.dkim2?.host" translate>
                common_copy
              </button>
            </td>
            <td class="border-left">{{ cNameConfiguraion?.dns?.dkim2?.data }}</td>
            <td>
              <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="cNameConfiguraion?.dns?.dkim2?.data" translate>
                common_copy
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <wsb-atlas-button
      variant="secondary"
      class="secondary me-3"
      data-dismiss="modal"
      (btnClick)="cancelEvent.emit()"
      [label]="labelCancelButton"
    ></wsb-atlas-button>
  </div>
</div>
